/**
 * orga app | datentransfer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface KommunikationRolleMitteilungOptionen { 
    mandant_id?: string;
    modified_on_utc?: string;
    darf_mitteilungen_senden?: boolean;
    funktionsbereich_id?: string;
    rolle_id?: string;
    senden_an_alle?: boolean;
    senden_an_beliebigen_funktionsbereich?: boolean;
    senden_an_eigenen_funktionsbereich?: boolean;
    senden_an_funktionsbereich_freigeber?: boolean;
}

